export default __webpack_public_path__ + "static/media/790246060823412746.cadfb15a.png";